import {Routes} from '@angular/router';
import {ShowComponent} from "./show/show.component";
import {AdminComponent} from "./admin/admin.component";
import {HomeComponent} from "./home/home.component";
import {ImprintComponent} from "./imprint/imprint.component";
import {FeaturesComponent} from "./features/features.component";
import {AdminListComponent} from "./admin/admin-list/admin-list.component";
import {AdminLoginComponent} from "./admin/admin-login/admin-login.component";
import {AdminGuard} from "./admin.guard";
import {AdminCodesComponent} from "./admin/admin-codes/admin-codes.component";
import {DemoComponent} from "./demo/demo.component";
import {PriceComponent} from "./price/price.component";

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'imprint',
        component: ImprintComponent,
    },
    {
        path: 'features',
        component: FeaturesComponent,
    },
    {
        path: 'demo',
        component: DemoComponent,
    },
    {
        path: 'price',
        component: PriceComponent,
    },
    {
        path: 'show/:code',
        component: ShowComponent,
    },
    {
        path: 'admin/:slug',
        component: AdminComponent,
        children: [
            {path: '', redirectTo: 'list', pathMatch: 'full'},
            {path: 'login', component: AdminLoginComponent},
            {path: 'list', component: AdminListComponent, canActivate: [AdminGuard]},
            {path: 'codes', component: AdminCodesComponent, canActivate: [AdminGuard]},
            {path: '**', redirectTo: 'list', pathMatch: 'full'}
        ]
    },
    {
        path: '**',
        component: HomeComponent,
    }
];
